var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class AppleClient {
    // Sign in with Apple JS を利用してAppleの認証を行う
    authenticate(nonce, clientId, redirectUri) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!window.AppleID) {
                throw new Error('no apple script embedded');
            }
            yield window.AppleID.auth.init({
                clientId: clientId,
                scope: 'email',
                redirectURI: redirectUri,
                nonce: nonce,
                usePopup: false,
            });
            // Appleの認証ページに遷移
            yield window.AppleID.auth.signIn();
        });
    }
}
